import { useFieldContext } from './shared';
import { useFormReadOnly } from './form-read-only';
import { AltTextInput } from './-components/alt-text-input';

export default function AltTextField(props: { placeholder?: string; tooltipText?: string }) {
	const field = useFieldContext<string>();
	const formReadOnly = useFormReadOnly();

	return (
		<AltTextInput
			value={field.state.value ?? ''}
			onChange={(v) => field.handleChange(v)}
			placeholder={props.placeholder}
			readOnly={formReadOnly}
			tooltipText={props.tooltipText}
		/>
	);
}
